import React from 'react'

const scrollToRef = (ref: React.MutableRefObject<any>) => {
    ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
export default scrollToRef
